var map = {
	"./blogBlog1.jpg": 75424,
	"./blogBlog10.jpg": 84835,
	"./blogBlog2.jpg": 53807,
	"./blogBlog3.jpg": 10698,
	"./blogBlog4.jpg": 52902,
	"./blogBlog5.jpg": 79430,
	"./blogBlog6.jpg": 71421,
	"./blogBlog7.jpg": 55968,
	"./blogBlog8.jpg": 37806,
	"./blogBlog9.jpg": 62594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42443;